import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
    name: 'auth',
    initialState: { user: null, token: null, pbitoken: null, workspaceId: null, workspaces: [], reportlist: {reports: [], nonPaginatedReportId: [], paginatedReportId: []}, selectedReportDetails: null, selectedReportId: null, userPreference: {locale: "en", defaultCulture: "en-US", themedark: false, timezone: "GST"}, reportSelectedIndex: 0, selectedReportObj:{}, lastUpdatedDate: [] },
    reducers: {
        setCredentials: (state, action) => {
            const { Token, username } = action.payload
            state.user = username
            state.token = Token 
            state.pbitoken = Token
        },
        setPBICredentials: (state, action) => {
            const { token } = action.payload
            state.pbitoken = token
        },
        setTenantWorkspace: (state, action) => {
            state.workspaceId = action.payload
        },
        setTenantWorkspacelist: (state, action) => {
            state.workspaces = action.payload
        },
        setPBIReportList: (state, action) => {
            state.reportlist.reports = action.payload
        },
        setSelectedReportId: (state, action) => {
            state.selectedReportId = action.payload
        },
        setSelectedReportDetails: (state, action) => {
            state.selectedReportDetails = action.payload
        },
        setUserPreference: (state, action) => {
            state.userPreference = action.payload
        },
        setReportSelectedIndex: (state, action) => {
            state.reportSelectedIndex = action.payload
        },
        logOut: (state, action) => {
            state.user = null
            state.token = null
            state.pbitoken = null
        },
        setSelectedReport: (state, action) => {
            state.selectedReportObj = action.payload
        },
        setReportLastUpadte: (state, action) => {
            state.lastUpdatedDate = action.payload
        },
    },
})

export const { setCredentials, setPBICredentials, setPBIReportList, setSelectedReportDetails, setTenantWorkspace, setTenantWorkspacelist, setSelectedReportId, setUserPreference, setReportSelectedIndex, logOut, setSelectedReport, setReportLastUpadte } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.user
export const selectCurrentToken = (state) => state.auth.token
export const selectPBICurrentToken = (state) => state.auth.pbitoken
export const selectPBIReportList = (state) => state.auth.reportlist.reports
export const selectPBIWorkspace = (state) => state.auth.workspaceId
export const selectPBIWorkspaceList = (state) => state.auth.workspaces
export const selectSelectedReportDetails = (state) => state.auth.selectedReportDetails
export const selectSelectedReportId = (state) => state.auth.selectedReportId
export const selectUserPreference = (state) => state.auth.userPreference
export const selectReportSelectedIndex = (state) => state.auth.reportSelectedIndex
export const selectSelectedReport = (state) => state.auth.selectedReportObj
export const selectReportLastUpadte = (state) => state.auth.lastUpdatedDate
